import { useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import DataContext from "../../../../../context/DataContext";
import useLogout from "../../../../../hooks/useLogout";

import SubMenu from "./SubMenu/components/SubMenu";

export default function RenderSubMenu() {
  const { loggedInUser } = useContext(DataContext);
  const navigate = useNavigate();
  const logout = useLogout();
  const subMenuList = [];
  const [searchParams, setSearchParams] = useSearchParams();

  const handleNavigate = (link) => {
    navigate(link);
  };

  subMenuList.push({
    menu: (
      <SubMenu
        title="My Account"
        onclick={handleNavigate}
        link={`/my-account?user=${loggedInUser.pk || loggedInUser.id}`}
      />
    ),
  });

  subMenuList.push({
    menu: <SubMenu title="Logout" onclick={logout} />,
  });

  return subMenuList;
}
